import React from "react";

interface SpinnerProps {
    color?: string;
    height?: number;
    width?: number;
    ariaLabel?: string;
 
}

const Spinner: React.FC<SpinnerProps> = ({
    color,
    ariaLabel,
    height,
    width ,
    ...rest
}) => {
    return (
        <div
            className="border-2 border-t-transparent rounded-full animate-spin"
            style={{
                borderColor: color,
                borderTopColor: "transparent",
                height,
                width,
                minHeight: height,
                minWidth: width,
            }}
            aria-label={ariaLabel}
            {...rest}
        />
    );
};

export default Spinner;
